import { isEmpty, mergeWith } from 'lodash';

export default {
  setAccessToken(state, accessToken = '') {
    state.accessToken = accessToken;
  },
  setUserData(
    state,
    userData = {
      userNo: 0,
      name: '',
      joinType: 'GENERAL',
      isSeller: false,
      status: 'ACTIVE',
      phone: '',
      isAuthPhone: false,
      file: {}
    }
  ) {
    state.userData = userData;
    state.deviceInfo.userNo = userData.userNo;
  },

  setPhoneInfo: (state, phone) => {
    state.userData.isSmsPhoneVerified = false;
    state.userData.phone = phone;
    state.userData.isAuthPhone = true;
  },

  setDeviceInfo: (
    state,
    deviceInfo = {
      userNo: null,
      deviceNo: null,
      deviceType: '',
      deviceId: '',
      pushToken: '',
      appVersion: '',
      os: ''
    }
  ) => {
    state.deviceInfo = deviceInfo;
  },
  setUpdateInfo: (state, updateInfo) => {
    state.updateInfo = updateInfo;
  },
  setLoginInfo: (
    state,
    loginInfo = {
      userNo: 0,
      loginStatus: '',
      loginDate: '',
      policyVersion: ''
    }
  ) => {
    state.loginInfo = loginInfo;
  },

  setJoinType(state, joinType = 'GENERAL') {
    state.userData.joinType = joinType;
  },

  setUserPosition(state, position) {
    state.position = position;
    console.log("user's position :: ", state.position);
  },
  resetUserPosition(state) {
    state.position.address = '';
    state.position.latitude = 0;
    state.position.longitude = 0;
    state.position.addressDetail = '';
  },
  setUserAddressDetail(state, { addressDetail }) {
    state.position.addressDetail = addressDetail ?? '';
  },
  setPoint(state, points) {
    state.points = points;
  },
  setCoupon(state, coupons) {
    state.coupons = coupons;
  },
  setSmsPhoneVerified(state, verified) {
    state.userData.isSmsPhoneVerified = verified === true;
  },
  setPhoneAuthState(state, { phone, isAuthPhone, isSmsPhoneVerified }) {
    Object.assign(state.userData, { phone, isAuthPhone, isSmsPhoneVerified: isSmsPhoneVerified === true });
  },
  setProfile(state, { name, phone, file, isAuthPhone, isSmsPhoneVerified }) {
    state.userData.name = name;
    state.userData.isAuthPhone = isAuthPhone;
    state.userData.isSmsPhoneVerified = isSmsPhoneVerified === true;
    state.userData.phone = phone;
    if (file) state.userData.file = file;
  },
  setInquiry(state, inquiry) {
    state.userData.inquiry = inquiry;
  },
  setIsPush: (state, isPush) => {
    state.userData.isPush = isPush;
  },
  setIsVoicePush: (state, isVoicePush) => {
    state.userData.isVoicePush = isVoicePush;
  },

  setStores: (state, stores = []) => {
    state.stores = stores;
  },

  setUserLocale: (state, locale = 'ko') => {
    state.userData.locale = locale.toUpperCase();
  },
  setProfileImage: (state, data) => {
    state.userData.file = data;
  },
  setAccess: (state, access = 0) => {
    state.access = access;
  },
  setUserStatus: (state, active) => {
    state.userData.status = active ? 'ACTIVE' : 'WITHDRAW';
  },

  setUserPushStatus: (state, { isPush, isVoicePush }) => {
    state.userData.isPush = isPush;
    state.userData.isVoicePush = isVoicePush;
  },

  setIsOnAlert: (state, isOnAlert) => {
    state.isOnAlert = isOnAlert;
  },

  updateAuthPhone: (state, phone) => {
    state.userData.isSmsPhoneVerified = phone.startsWith('84+');
    state.userData.phone = phone;
    state.userData.isAuthPhone = true;
  }
};
